<template>
  <v-card class="select-account">
    <v-card-title class="justify-center">
      {{ title }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-autocomplete
          outlined
          :items="accountItems"
          v-model="selectedAccount"
        >
          <template #item="{ parent, item }">
            <v-list-item-content class="text-left">
              <div v-if="item.name">
                <span style="font-size: medium; font-weight: 400">{{
                  item.name
                }}</span>
              </div>
              <div v-if="item.company">
                <span style="font-size: small; color: #828282">{{
                  item.company
                }}</span>
              </div>
              <div v-if="item.post">
                <span style="font-size: small; color: #828282">{{
                  item.post
                }}</span>
              </div>
              <div v-if="item.email">
                <span style="font-size: small; color: #828282">{{
                  item.email
                }}</span>
              </div>
              <!-- <v-list-item-title
                v-html="parent.genFilteredText(item.name)"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-if="item.company"
                v-html="parent.genFilteredText(item.company)"
              >
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="item.post"
                v-html="parent.genFilteredText(item.post)"
              >
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="item.email"
                v-html="parent.genFilteredText(item.email)"
              >
              </v-list-item-subtitle> -->
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :disabled="!selectedAccount"
        @click="$emit('submit', selectedAccount)"
        depressed
        large
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "SelectAccountDialog",
  props: {
    title: String,
    extraParams: Object,
  },
  setup(props, { root, emit }) {
    const selectedAccount = ref(null);
    const accounts = ref([]);
    const accountText = function (a) {
      return `${a.name} ${a.post ? "<" + a.post + ">" : ""} ${
        a.company ? "(" + a.company + ")" : ""
      } {${a.username}}`;
    };
    const accountItems = computed(() => {
      const ac = accounts.value.map((a) => {
        return {
          ...a,
          text: accountText(a),
          value: a,
        };
      });

      return ac;
    });

    const getAccounts = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/user/",
        params: {
          ...props.extraParams,
          page_size: -1,
        },
      });

      if (response.body.success) {
        accounts.value = response.body.users;
      }
    };

    onMounted(() => {
      getAccounts();
    });
    return {
      selectedAccount,

      accountItems,
      accountText,
    };
  },
};
</script>

<style lang="less">
.import-section {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
